const headerSearch = (menuSelector, searchSelector) => {
    const menu = document.querySelector(menuSelector);
    const search = document.querySelector(searchSelector);
    const searchInput = search.querySelector('input[name="search_string"]');
    const showBtn = document.querySelector(`${searchSelector}__icon__active`);
    const hideBtn = document.querySelector(`${searchSelector}__icon__close`);
    const showSearch = () => {
        return (event) => {
            menu.classList.add('hide');
            search.classList.remove('hide');
            showBtn.classList.add('hide');
            hideBtn.classList.remove('hide');
            searchInput.focus();
            console.log(searchInput);
        };
    };
    const hideSearch = () => {
        return (event) => {
            menu.classList.remove('hide');
            search.classList.add('hide');
            showBtn.classList.remove('hide');
            hideBtn.classList.add('hide');
        };
    };
    const showHandler = showSearch();
    const hideHandler = hideSearch();
    showBtn && showBtn.addEventListener('click', showHandler);
    hideBtn && hideBtn.addEventListener('click', hideHandler);
};
export default headerSearch;
